import './index_web.css';
import React from 'react';
import useTheme from '../../utilities/hooks/theme';
import { convertToDollars, RoundedOffAmount } from '../../utilities/helper';
// import Card from '../card';
import Constants from '../../constants';
import View from '../view';
import Text from '../text';
import Tooltip from '@mui/material/Tooltip';

type walletTypeProps = {
  title?: String | undefined;
  value?: any;
  theme?: any;
};

const WalletType = ({ title, value = 0, theme }: walletTypeProps) => {
  const contentTextColor = {
    color: '#fff'
  };
  const statusItemNameStyle = {
    background: theme.transactionHistoryStatusItemBg,
    color: theme.transactionHistoryStatusItemTextColor
  };
  value = RoundedOffAmount(value);
  if (value <= 0) return null;
  return (
    <View className={'transaction-game-item-wallet-type-wrapper'}>
      <Text
        style={statusItemNameStyle}
        className={'transaction-game-item-wallet-type-title__web'}>{`${title}:`}</Text>
      <div>
        <Text
          style={contentTextColor}
          className={'transaction-game-item-wallet-type-value'}>{` - ${convertToDollars(
          value
        )}/-`}</Text>
      </div>
    </View>
  );
};

interface Props {
  item: any;
}

const TransactionGameItemWeb = ({ item }: Props) => {
  const { AccountTheme: theme } = useTheme();
  const {
    amount = 0,
    gameId = '',
    refund = '',
    transactionType = '',
    totalTax = 0,
    comment = null,
    transfer = false,
    isPoker = false,
    walletBreakup
  } = item;

  const newAmount = RoundedOffAmount(amount);

  const statusTextColor = {
    color:
      transactionType === 'debit'
        ? theme.transactionHistoryGameItemValueDebitBg
        : theme.transactionHistoryGameItemValueCreditBg
  };
  transactionType === 'debit' ? '#ff4b4b' : '#17b443';

  const simpleTextColor = {
    color: theme.transactionDateTime
  };
  const statusContainerStyle = {
    background: theme.transactionHistoryStatusContainerBg,
    boxShadow: theme.transactionHistoryStatusContainerBoxShadow,
    border: `2px solid ${theme.transactionHistoryBorder}`
  };

  const isTransfer = transfer && !gameId;
  return (
    <>
      <View className={'transaction-games-item-header'}>
        <View className={'transaction-game-item-header-wrapper '}>
          <View className={'transaction-game-item-left-part'}>
            {transactionType === 'debit' && (
              <Text
                style={{
                  ...statusTextColor,
                  fontFamily: 'Poppins',
                  fontWeight: 600,
                  fontSize: '1.1rem'
                }}
                className={'transaction-game-item-header'}>
                {isPoker ? 'Join Room / Buy In' : 'Joined Contest'}
              </Text>
            )}

            {transactionType === 'credit' && (
              <Text
                style={{
                  ...statusTextColor,
                  fontFamily: 'Poppins',
                  fontWeight: 600,
                  fontSize: '1.1rem'
                }}
                className={'transaction-game-item-header'}>
                {refund
                  ? 'Got Refund'
                  : isPoker
                  ? 'Credited Back'
                  : comment
                  ? 'Winning adjustment'
                  : isTransfer
                  ? 'Transfer'
                  : 'Won Contest'}
              </Text>
            )}
            {comment && (
              <Text
                style={simpleTextColor}
                className={'transaction-game-item-content-text'}>{`Comment : ${comment}`}</Text>
            )}
          </View>
          <View className={'transaction-game-item-right-part'}>
            <Text
              style={{
                ...statusTextColor,
                fontFamily: 'Poppins',
                fontWeight: 600,
                fontSize: '1.1rem'
              }}
              className={'transaction-game-item-amount'}>
              {`${transactionType === 'credit' ? '+' : '-'} ${convertToDollars(newAmount)}`}
            </Text>
          </View>
        </View>
      </View>
      <Tooltip
        placement="top"
        componentsProps={{
          tooltip: {
            sx: {
              backgroundColor: 'transparent'
            }
          }
        }}
        title={
          <div className="transactional_table_game_status_container" style={statusContainerStyle}>
            {totalTax > 0 && transactionType === 'credit' && (
              <WalletType title={'TDS'} value={`₹ ${totalTax}`} theme={theme} />
            )}
            {transactionType == 'credit' && refund ? (
              <>
                <WalletType
                  title={'iGamio Wallet'}
                  value={`${walletBreakup['primaryWalletRefund']}`}
                  theme={theme}
                />

                <WalletType
                  title={'Winnings Wallet'}
                  value={`${walletBreakup['gameWalletRefund']}`}
                  theme={theme}
                />

                <WalletType
                  title={'Bonus Wallet'}
                  value={`${walletBreakup['bonusWalletRefund']}`}
                  theme={theme}
                />
                <WalletType
                  title={'CashBack Wallet'}
                  value={`${walletBreakup['cashbackWalletRefund']}`}
                  theme={theme}
                />
                {isPoker && (
                  <WalletType
                    title={'Poker Wallet'}
                    value={`${walletBreakup['pokerWalletRefund']}`}
                    theme={theme}
                  />
                )}
              </>
            ) : transactionType == 'credit' ? (
              <>
                {isPoker ? (
                  <WalletType
                    title={'Poker Wallet'}
                    value={`${walletBreakup['totalWinnings']}`}
                    theme={theme}
                  />
                ) : (
                  <WalletType
                    title={'Winnings Wallet'}
                    value={`${walletBreakup['totalWinnings']}`}
                    theme={theme}
                  />
                )}
              </>
            ) : (
              <>
                <WalletType
                  title={'iGamio Wallet'}
                  value={`${walletBreakup['primaryWalletEntryFee']}`}
                  theme={theme}
                />

                <WalletType
                  title={'Winnings Wallet'}
                  value={`${walletBreakup['gameWalletEntryFee']}`}
                  theme={theme}
                />

                <WalletType
                  title={'Bonus Wallet'}
                  value={`${walletBreakup['bonusWalletEntryFee']}`}
                  theme={theme}
                />
                <WalletType
                  title={'CashBack Wallet'}
                  value={`${walletBreakup['cashbackWalletEntryFee']}`}
                  theme={theme}
                />
                {isPoker && (
                  <WalletType
                    title={'Poker Wallet'}
                    value={`${walletBreakup['pokerWalletEntryFee']}`}
                    theme={theme}
                  />
                )}
              </>
            )}
          </div>
        }>
        <div className="games_details_text_container">
          <Constants.Svgs.Info color={'#ffffff'} />
          <p>Details</p>
        </div>
      </Tooltip>
    </>
  );
};
TransactionGameItemWeb.defaultProps = {};
export default React.memo(TransactionGameItemWeb);
